module.exports = __webpack_public_path__ + "static/media/logo-netent.b101507f.svg";